import { SelectBox } from "devextreme-react";
import { Col, Row } from "react-bootstrap";
import CalculatedEventsItem from "./CalculatedEventsItem";
import CalculatedEventsField from "./CalculatedEventsField";
import CalculatedEventRunsItem from "./CalculatedEventRunsItem";
import CalculatedEventRunsField from "./CalculatedEventRunsField";

const SurchargeSelectBox = (props: any) => {
  return (
    <Row>
      <Col>
        <SelectBox
          label="Surcharge Event"
          dataSource={props.calculatedEvents}
          value={props.selectedSurchargeEvent}
          defaultValue={props.selectedSurchargeEvent}
          itemRender={CalculatedEventsItem}
          // fieldRender={CalculatedEventsField}
          onValueChange={props.handleSurchargeEventChange}
          displayExpr="displayData"
          // valueExpr="id"
        />
      </Col>
      <Col>
        <SelectBox
          label="Surcharge Event Calculation Run"
          dataSource={props.calculatedEventRuns}
          value={props.selectedCalculatedEventRun}
          defaultValue={props.selectedCalculatedEventRun}
          itemRender={CalculatedEventRunsItem}
          // fieldRender={CalculatedEventRunsField}
          onValueChange={props.handleSurchargeEventRunChange}
          displayExpr="displayData"
          // valueExpr="id"
        />
      </Col>
    </Row>
  );
};

export default SurchargeSelectBox;
